import styled from 'styled-components';
import { FLUENT_UI_EMOJIS } from '../../assets';

export const StartingOutIcon = styled(FLUENT_UI_EMOJIS.EGG)``;

export const SomewhatExperiencedIcon = styled(FLUENT_UI_EMOJIS.HATCHING_CHICK)``;

export const HighlyExperiencedIcon = styled(FLUENT_UI_EMOJIS.ROOSTER)``;

export const IncrediblyExperiencedIcon = styled(FLUENT_UI_EMOJIS.PEACOCK)``;
